import { px, rect, aRect } from '../../../pixel/canvas';
import type { Part } from '../../types';

export const exhausts: Record<string, Part> = {
  exhaust_flame: {
    id: 'exhaust_flame',
    category: 'exhaust',
    name: 'Flame',
    requires: 'exhaust_pair',
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.exhaust); aRect(ctx, a.x, a.y + 1, 2, 1, p.exhaustCool); aRect(ctx, a.x, a.y, 2, 1, p.exhaustHot); aRect(ctx, a.x, a.y + 2, 2, 1, p.exhaustCool); },
    frames: [
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.exhaust); aRect(ctx, a.x, a.y + 1, 2, 1, p.exhaustCool); aRect(ctx, a.x, a.y, 2, 1, p.exhaustHot); aRect(ctx, a.x, a.y + 2, 2, 1, p.exhaustCool); } },
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.exhaustHot); aRect(ctx, a.x, a.y + 1, 2, 1, p.exhaust); aRect(ctx, a.x, a.y, 2, 1, p.exhaustHot); aRect(ctx, a.x, a.y + 2, 2, 1, p.exhaust); } },
    ],
  },
  exhaust_plasma: {
    id: 'exhaust_plasma',
    category: 'exhaust',
    name: 'Plasma',
    requires: 'exhaust_pair',
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 2, p.glass); aRect(ctx, a.x, a.y, 2, 1, p.glassLight); aRect(ctx, a.x, a.y + 2, 2, 1, p.glassDark); },
    frames: [
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 2, p.glass); aRect(ctx, a.x, a.y, 2, 1, p.glassLight); aRect(ctx, a.x, a.y + 2, 2, 1, p.glassDark); } },
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 2, p.glassLight); aRect(ctx, a.x, a.y, 2, 1, p.glassLight); aRect(ctx, a.x, a.y + 2, 2, 1, p.glass); } },
    ],
  },
  exhaust_ion: {
    id: 'exhaust_ion',
    category: 'exhaust',
    name: 'Ion',
    requires: 'exhaust_pair',
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 2, p.accent); rect(ctx, a.x - 1, a.y + 2, 1, 1, p.accent); rect(ctx, a.x + 1, a.y + 2, 1, 1, p.accent); },
    frames: [
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 2, p.accent); rect(ctx, a.x - 1, a.y + 2, 1, 1, p.accent); rect(ctx, a.x + 1, a.y + 2, 1, 1, p.accent); } },
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 2, p.accentLight); rect(ctx, a.x - 1, a.y + 2, 1, 1, p.accent); rect(ctx, a.x + 1, a.y + 2, 1, 1, p.accent); } },
    ],
  },
  exhaust_smoke: {
    id: 'exhaust_smoke',
    category: 'exhaust',
    name: 'Smoke',
    requires: 'exhaust_pair',
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.smoke); rect(ctx, a.x - 2, a.y + 1, 1, 1, p.smoke); rect(ctx, a.x + 1, a.y + 1, 1, 1, p.smoke); aRect(ctx, a.x, a.y + 2, 2, 1, p.smoke); },
    frames: [
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.smoke); rect(ctx, a.x - 2, a.y + 1, 1, 1, p.smoke); rect(ctx, a.x + 1, a.y + 1, 1, 1, p.smoke); aRect(ctx, a.x, a.y + 2, 2, 1, p.smoke); } },
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.metalDark); rect(ctx, a.x - 2, a.y + 1, 1, 1, p.smoke); rect(ctx, a.x + 1, a.y + 1, 1, 1, p.metalDark); aRect(ctx, a.x, a.y + 2, 2, 1, p.smoke); } },
    ],
  },
  exhaust_sparks: {
    id: 'exhaust_sparks',
    category: 'exhaust',
    name: 'Sparks',
    requires: 'exhaust_pair',
    draw: (ctx, a, p) => { px(ctx, a.x - 1, a.y, p.exhaust); px(ctx, a.x, a.y, p.exhaustHot); rect(ctx, a.x - 2, a.y + 1, 1, 1, p.exhaust); rect(ctx, a.x + 1, a.y + 2, 1, 1, p.exhaustCool); px(ctx, a.x - 1, a.y + 3, p.exhaust); },
    frames: [
      { draw: (ctx, a, p) => { px(ctx, a.x - 1, a.y, p.exhaust); px(ctx, a.x, a.y, p.exhaustHot); rect(ctx, a.x - 2, a.y + 1, 1, 1, p.exhaust); rect(ctx, a.x + 1, a.y + 2, 1, 1, p.exhaustCool); px(ctx, a.x - 1, a.y + 3, p.exhaust); } },
      { draw: (ctx, a, p) => { px(ctx, a.x - 1, a.y, p.exhaustHot); px(ctx, a.x, a.y, p.exhaust); rect(ctx, a.x - 2, a.y + 1, 1, 1, p.exhaustHot); rect(ctx, a.x + 1, a.y + 2, 1, 1, p.exhaust); px(ctx, a.x - 1, a.y + 3, p.exhaustCool); } },
    ],
  },
  exhaust_twin: {
    id: 'exhaust_twin',
    category: 'exhaust',
    name: 'Twin Flame',
    requires: 'exhaust_pair',
    draw: (ctx, a, p) => { rect(ctx, a.x - 1, a.y, 1, 3, p.exhaust); rect(ctx, a.x, a.y, 1, 3, p.exhaust); rect(ctx, a.x - 1, a.y, 1, 1, p.exhaustHot); rect(ctx, a.x, a.y, 1, 1, p.exhaustHot); rect(ctx, a.x - 1, a.y + 3, 1, 1, p.exhaustCool); rect(ctx, a.x, a.y + 3, 1, 1, p.exhaustCool); },
    frames: [
      { draw: (ctx, a, p) => { rect(ctx, a.x - 1, a.y, 1, 3, p.exhaust); rect(ctx, a.x, a.y, 1, 3, p.exhaust); rect(ctx, a.x - 1, a.y, 1, 1, p.exhaustHot); rect(ctx, a.x, a.y, 1, 1, p.exhaustHot); rect(ctx, a.x - 1, a.y + 3, 1, 1, p.exhaustCool); rect(ctx, a.x, a.y + 3, 1, 1, p.exhaustCool); } },
      { draw: (ctx, a, p) => { rect(ctx, a.x - 1, a.y, 1, 3, p.exhaustHot); rect(ctx, a.x, a.y, 1, 3, p.exhaustHot); rect(ctx, a.x - 1, a.y, 1, 1, p.exhaustHot); rect(ctx, a.x, a.y, 1, 1, p.exhaust); rect(ctx, a.x - 1, a.y + 3, 1, 1, p.exhaust); rect(ctx, a.x, a.y + 3, 1, 1, p.exhaustCool); } },
    ],
  },
  exhaust_ember: {
    id: 'exhaust_ember',
    category: 'exhaust',
    name: 'Ember',
    requires: 'exhaust_pair',
    draw: (ctx, a, p) => { px(ctx, a.x - 1, a.y, p.exhaust); px(ctx, a.x, a.y + 1, p.exhaustHot); px(ctx, a.x + 1, a.y + 2, p.exhaust); px(ctx, a.x - 1, a.y + 3, p.exhaustCool); },
    frames: [
      { draw: (ctx, a, p) => { px(ctx, a.x - 1, a.y, p.exhaust); px(ctx, a.x, a.y + 1, p.exhaustHot); px(ctx, a.x + 1, a.y + 2, p.exhaust); px(ctx, a.x - 1, a.y + 3, p.exhaustCool); } },
      { draw: (ctx, a, p) => { px(ctx, a.x - 1, a.y, p.exhaustHot); px(ctx, a.x, a.y + 1, p.exhaust); px(ctx, a.x + 1, a.y + 2, p.exhaustCool); px(ctx, a.x - 1, a.y + 3, p.exhaust); } },
    ],
  },
  exhaust_burst: {
    id: 'exhaust_burst',
    category: 'exhaust',
    name: 'Burst',
    requires: 'exhaust_pair',
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.exhaustHot); px(ctx, a.x - 1, a.y + 1, p.exhaust); px(ctx, a.x, a.y + 1, p.exhaust); px(ctx, a.x - 2, a.y + 2, p.exhaustCool); px(ctx, a.x + 1, a.y + 2, p.exhaustCool); },
    frames: [
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.exhaustHot); px(ctx, a.x - 1, a.y + 1, p.exhaust); px(ctx, a.x, a.y + 1, p.exhaust); px(ctx, a.x - 2, a.y + 2, p.exhaustCool); px(ctx, a.x + 1, a.y + 2, p.exhaustCool); } },
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.exhaust); px(ctx, a.x - 2, a.y + 1, p.exhaustHot); px(ctx, a.x + 1, a.y + 1, p.exhaustHot); px(ctx, a.x - 1, a.y + 2, p.exhaust); px(ctx, a.x, a.y + 2, p.exhaust); } },
    ],
  },
  exhaust_arc: {
    id: 'exhaust_arc',
    category: 'exhaust',
    name: 'Arc',
    requires: 'exhaust_pair',
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.accentLight); px(ctx, a.x - 1, a.y + 1, p.accent); aRect(ctx, a.x, a.y + 2, 2, 1, p.accentDark); },
    frames: [
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.accentLight); px(ctx, a.x - 1, a.y + 1, p.accent); px(ctx, a.x, a.y + 2, p.accentDark); } },
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.accent); px(ctx, a.x, a.y + 1, p.accentLight); px(ctx, a.x - 1, a.y + 2, p.accentDark); } },
    ],
  },
  exhaust_void: {
    id: 'exhaust_void',
    category: 'exhaust',
    name: 'Void',
    requires: 'exhaust_pair',
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 2, p.dark); px(ctx, a.x - 1, a.y + 2, p.glassDark); px(ctx, a.x, a.y + 2, p.glass); },
    frames: [
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 2, p.dark); px(ctx, a.x - 1, a.y + 2, p.glassDark); px(ctx, a.x, a.y + 2, p.glass); } },
      { draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 2, p.dark); px(ctx, a.x - 1, a.y + 2, p.glass); px(ctx, a.x, a.y + 2, p.glassDark); } },
    ],
  },
};
